import React from "react";
import "../styles/Footer.css";
import Instagram from "../images/instagram.png";
import Facebook from "../images/facebook-logo-2019.png";
import Linkedin from "../images/linkedin.png";
import Pinterest from "../images/pinterest.png";
import Youtube from "../images/youtube.png";
import Whatsapp from "../images/whatsapp.png";

function Footer() {
  return (
    <div className="footer">
      <div className="container footer_row">
        <div className="footer_one">
          <h3>About Us</h3>
          <p>
            We are a team of designers and developers to make your life easier
            by providing Digital Solutions.{" "}
          </p>
        </div>

        <div className="footer_three">
          <h3>Social Links</h3>
          
          <p>
            <div className="footer_mail">
              <img src={Whatsapp} alt="" />
              <a href="https://wa.me/message/ICKONGKPPDX2L1"> WhatsApp</a>{" "}
            </div>
          </p>
          <p>
            <div className="footer_mail">
              <img src={Instagram} alt="" />
              <a href="https://instagram.com/navicreativesmediamart?utm_medium=copy_link">
                Instagram
              </a>
            </div>
          </p>
          <p>
            <div className="footer_mail">
              <img src={Facebook} alt="" />
              <a href="https://www.facebook.com/Navicreativesmediamart/"> Facebook</a>{" "}
            </div>
          </p>
          <p>
            <div className="footer_mail">
              <img src={Linkedin} alt="" />
              <a href="https://www.linkedin.com/in/navi-creatives-media-mart-19a8931b9">
                {" "}
                Linkedin
              </a>
            </div>
          </p>
          <p>
            <div className="footer_mail">
              <img src={Pinterest} alt="" />
               <a href="https://pin.it/2WvmdCA"> Pinterest</a>
            </div>
          </p>
          <p>
            <div className="footer_mail">
              <img src={Youtube} alt="" /> 
              <a href="https://youtube.com/channel/UC8ThlTbpVbnUw32uVwKkJJw"> Youtube</a>
            </div>
          </p>
        </div>
        <div className="footer_two">
          <h3>Contact Us</h3>

          <p>
            <label htmlFor="phone">Phone : </label>
            <br />
            <a className="" href="tel:+919326300785">
              +919326300785
            </a>
          </p>
          <p>
            <label htmlFor="email">Email : </label>
            <br />
            <a href="mailto:navicreatives@gmail.com">navicreatives@gmail.com</a>
            <br />
            <a href="mailto:infonavievents@gmail.com">infonavievents@gmail.com</a>
          </p>
          <p>
            <label htmlFor="address">Address :</label>
            <br />
            Mumbai, Maharashtra
          </p>
        </div>
      </div>
    </div>
  );
}

export default Footer;
